import HelperMixin from '../../../Shared/HelperMixin.vue'
import eventBus from '../../../Shared/EventBus.js';
import notificationRealtime from '../../../Shared/NotificationRealtime.js';
export default {
    name: 'AppHeader',
    mixins: [HelperMixin],
    async created() {

        await this.CheckLoginStatus();
        if (this.loginDetails) {
            if (!this.isSupportedPortalUser())
                this.logout();
            else if (this.canUseNotificationsUi()) {
                await this.loadNotificationsSummary(false);
                await this.startRealtimeNotifications();
                this.startNotificationsPolling();
            }

        }

        eventBus.$on('notifications:changed', this.handleNotificationsChanged);
    },
    beforeDestroy() {
        this.stopNotificationsPolling();
        this.stopRealtimeNotifications();
        eventBus.$off('notifications:changed', this.handleNotificationsChanged);
    },
    data() {
        return {  
            Info: [],
            TempInfo: [],
            Count: 0,
            notifications: [],
            unreadCount: 0,
            latestNotificationId: null,
            notificationsBootstrapped: false,
            showNotificationsPreview: false,
            notificationsPollTimer: null,
            audioContext: null,
            realtimeHandler: null
        };
    },
  
    methods: {

        //href(url) {
        //    this.$router.push(url);
        //},
        href(url, id) {

            if (this.$route.path === url) 
                return; // Do nothing if the current URL matches the target URL

            this.$router.push(url);
            for (var i = 0; i < 20; i++) {
                if (i == id) {
                    this.$set(this.menuFlag, id, '');
                } else {
                    this.$set(this.menuFlag, i, '');
                }
            }
        },
        handleNotificationsChanged() {
            if (!this.canUseNotificationsUi()) return;
            this.loadNotificationsSummary(false);
        },
        async loadNotificationsSummary(playSoundIfNew = true) {
            if (!this.canUseNotificationsUi()) return;

            try {
                const response = await this.$http.GetNotificationsSummary();
                const summary = response.data || {};
                const latest = summary.latest || [];
                const unreadCount = Number(summary.unreadCount || 0);
                const latestId = summary.latestId || (latest.length ? latest[0].id : null);
                const shouldPlaySound =
                    this.notificationsBootstrapped &&
                    latestId &&
                    latestId !== this.latestNotificationId &&
                    unreadCount >= this.unreadCount;

                this.notifications = latest;
                this.unreadCount = unreadCount;
                this.latestNotificationId = latestId;

                if (shouldPlaySound && playSoundIfNew) {
                    this.playNotificationSound();
                }

                this.notificationsBootstrapped = true;
            } catch {
                this.notifications = [];
                this.unreadCount = 0;
            }
        },
        startNotificationsPolling() {
            this.stopNotificationsPolling();
            this.notificationsPollTimer = window.setInterval(() => {
                this.loadNotificationsSummary(true);
            }, 120000);
        },
        stopNotificationsPolling() {
            if (this.notificationsPollTimer) {
                window.clearInterval(this.notificationsPollTimer);
                this.notificationsPollTimer = null;
            }
        },
        async startRealtimeNotifications() {
            if (this.realtimeHandler) return;

            this.realtimeHandler = () => {
                this.loadNotificationsSummary(true);
                eventBus.$emit('notifications:changed');
            };

            notificationRealtime.onPulse(this.realtimeHandler);
            try {
                await notificationRealtime.start();
            } catch {
                // Keep polling as a fallback when realtime is unavailable.
            }
        },
        stopRealtimeNotifications() {
            if (this.realtimeHandler) {
                notificationRealtime.offPulse(this.realtimeHandler);
                this.realtimeHandler = null;
            }
        },
        notificationIcon(item) {
            const category = item && item.category ? item.category : 'general';
            if (category === 'inventory') return 'ti ti-alert-triangle';
            if (category === 'direct-dispatch') return 'ti ti-truck-delivery';
            if (category === 'receipt-verification') return 'ti ti-clipboard-check';
            if (category === 'medicine-order') return 'ti ti-package';
            return 'ti ti-bell';
        },
        async markNotificationRead(item) {
            if (!item || item.isRead) return;

            try {
                await this.$http.MarkNotificationRead(item.id);
                item.isRead = true;
                this.unreadCount = Math.max(0, this.unreadCount - 1);
                eventBus.$emit('notifications:changed');
            } catch {
                // Ignore transient notification errors in the header preview.
            }
        },
        async markAllNotificationsRead() {
            try {
                await this.$http.MarkAllNotificationsRead();
                this.notifications = (this.notifications || []).map((item) => ({ ...item, isRead: true }));
                this.unreadCount = 0;
                eventBus.$emit('notifications:changed');
            } catch {
                // Ignore transient notification errors in the header preview.
            }
        },
        async openNotification(item) {
            if (!item) return;

            await this.markNotificationRead(item);
            this.showNotificationsPreview = false;

            const path = item.actionPath || '/Notifications';
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        },
        openAllNotifications() {
            this.showNotificationsPreview = false;
            if (this.$route.path !== '/Notifications') {
                this.$router.push('/Notifications');
            }
        },
        async showNotificationsPanel() {
            this.showNotificationsPreview = true;
            await this.loadNotificationsSummary(false);
        },
        playNotificationSound() {
            try {
                const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
                if (!AudioContextCtor) return;

                if (!this.audioContext) {
                    this.audioContext = new AudioContextCtor();
                }
                if (this.audioContext.state === 'suspended') {
                    this.audioContext.resume();
                }

                const oscillator = this.audioContext.createOscillator();
                const gainNode = this.audioContext.createGain();
                oscillator.type = 'sine';
                oscillator.frequency.setValueAtTime(880, this.audioContext.currentTime);
                gainNode.gain.setValueAtTime(0.0001, this.audioContext.currentTime);
                gainNode.gain.exponentialRampToValueAtTime(0.12, this.audioContext.currentTime + 0.02);
                gainNode.gain.exponentialRampToValueAtTime(0.0001, this.audioContext.currentTime + 0.22);
                oscillator.connect(gainNode);
                gainNode.connect(this.audioContext.destination);
                oscillator.start();
                oscillator.stop(this.audioContext.currentTime + 0.22);
            } catch {
                // Browsers may block autoplay audio until the user interacts with the page.
            }
        }

    }    
}
